import { render, staticRenderFns } from "./TeacherLevelForm.vue?vue&type=template&id=5cabcb57&scoped=true&"
import script from "./TeacherLevelForm.vue?vue&type=script&lang=js&"
export * from "./TeacherLevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabcb57",
  null
  
)

export default component.exports